import { Container, Row } from "reactstrap"
import { Breadcrumbs } from "../../../AbstractElements"
import { FormWidgets, Switch } from "../../../Constant"
import CustomSwitch from "./CustomSwitch";
import Iconsswitch from "./Iconsswitch";
import UncheckedSwitch from "./UncheckedSwitch";
import BordersWithIcons from "./BordersWithIcons";
import DisabledOutlineSwitch from "./DisabledOutlineSwitch";
import VariationOfSwitches from "./VariationOfSwitches";
import SwitchSizing from "./SwitchSizing";
import SwitchWithIcons from "./SwitchWithIcons";


const SwitchContainer = () => {
  return (
    <>
    <Breadcrumbs pageTitle={Switch} parent={FormWidgets} title={Switch} />
    <Container fluid>
     <Row>
       <CustomSwitch/>
       <Iconsswitch/>
       <UncheckedSwitch/>
       <BordersWithIcons/>
       <DisabledOutlineSwitch/>
       <VariationOfSwitches/>
       <SwitchSizing/>
       <SwitchWithIcons/>
     </Row>
    </Container>
    </>
   )
};

export default SwitchContainer;
